import { useErrorToast } from '../lib/useErrorToast';
import { useAnalysesQuery } from '../api/queries/analyses';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { StatusIndicator } from '../components/StatusIndicator';

export function Analyses() {
  const analysesQuery = useAnalysesQuery();

  useErrorToast(analysesQuery.error);

  const analyses = (analysesQuery.data?.analyses || []).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <div className="h-full overflow-scroll p-8 bg-white">
      {analyses.length === 0 ? (
        <div>No analyses found</div>
      ) : (
        <ul className="flex flex-col gap-2">
          {analyses.map((analysis) => (
            <Link
              to={`/a/${analysis.slug}`}
              key={analysis.id}
              className="py-4 bg-white border-b border-black hover:border-orange-2 hover:text-orange-2 px-2"
            >
              <li className="flex justify-between">
                <div className="flex items-center gap-2">
                  <StatusIndicator
                    status={analysis.status}
                    statuses={{
                      PENDING: {
                        color: '#ffc107',
                        pulse: true
                      },
                      COMPLETED: {
                        color: '#28a745'
                      },
                      FAILED: {
                        color: '#dc3545'
                      },
                      CANCELLED: {
                        color: '#dc3545'
                      }
                    }}
                  />
                  <p>{analysis.name}</p>
                </div>
                <p>
                  {format(
                    new Date(analysis.startedAt ?? '0'),
                    'MM-dd-yyyy - KK:mmaaa'
                  )}
                </p>
              </li>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}
